"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactRouterDom = require("react-router-dom");

var _compose = _interopRequireDefault(require("ramda/src/compose"));

var _partial = _interopRequireDefault(require("ramda/src/partial"));

var _path = _interopRequireDefault(require("ramda/src/path"));

var _map = _interopRequireDefault(require("ramda/src/map"));

var _contexts = require("../../contexts");

var _utils = require("../../utils");

var _useNavigation = require("./useNavigation");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  activeStep: _propTypes.string,
  onChange: _propTypes.func,
  children: _propTypes.node.isRequired
} : {};
var defaultProps = {
  onChange: function onChange() {
    return null;
  }
};
var stepsToPath = (0, _map.default)((0, _compose.default)((0, _partial.default)(_utils.addPrefix, '/'), (0, _path.default)(['props', 'name'])));

var Stepper = function Stepper(_ref) {
  var activeStep = _ref.activeStep,
      onChange = _ref.onChange,
      children = _ref.children;
  var steps = stepsToPath(_react.default.Children.toArray(children));

  var _ref2 = (0, _useNavigation.useNavigation)({
    steps: steps,
    activeStep: activeStep,
    onChange: onChange
  }),
      history = _ref2.history,
      navigationProps = _objectWithoutProperties(_ref2, ["history"]);

  var contextProps = _objectSpread({
    steps: steps,
    history: history
  }, navigationProps);

  return (0, _core.jsx)(_contexts.StepperContext.Provider, {
    value: contextProps
  }, (0, _core.jsx)(_reactRouterDom.Router, {
    history: history
  }, children));
};

exports.Stepper = Stepper;
process.env.NODE_ENV !== "production" ? Stepper.propTypes = propTypes : void 0;
Stepper.defaultProps = defaultProps;
Stepper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Stepper",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activeStep": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};